export default function TrainIcon() {
  return (
    <svg
      width="14"
      height="17"
      viewBox="0 0 14 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.99992 0.666992C3.66659 0.666992 0.333252 1.08366 0.333252 4.00033V11.917C0.333252 13.5253 1.64159 14.8337 3.24992 14.8337L1.99992 16.0837V16.5003H3.85825L5.52492 14.8337H8.66659L10.3333 16.5003H11.9999V16.0837L10.7499 14.8337C12.3583 14.8337 13.6666 13.5253 13.6666 11.917V4.00033C13.6666 1.08366 10.6833 0.666992 6.99992 0.666992ZM3.24992 13.167C2.55825 13.167 1.99992 12.6087 1.99992 11.917C1.99992 11.2253 2.55825 10.667 3.24992 10.667C3.94159 10.667 4.49992 11.2253 4.49992 11.917C4.49992 12.6087 3.94159 13.167 3.24992 13.167ZM6.16659 7.33366H1.99992V4.00033H6.16659V7.33366ZM7.83325 7.33366V4.00033H11.9999V7.33366H7.83325ZM10.7499 13.167C10.0583 13.167 9.49992 12.6087 9.49992 11.917C9.49992 11.2253 10.0583 10.667 10.7499 10.667C11.4416 10.667 11.9999 11.2253 11.9999 11.917C11.9999 12.6087 11.4416 13.167 10.7499 13.167Z"
        fill="#323232"
      />
    </svg>
  );
}
